import { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { JobContext } from "../../../context/JobContext";

const JobEditPage = () => {
  const { id } = useParams();

  const { states, actions } = useContext(JobContext);
  const { form, data } = states;
  const { setForm, setCurrentID, handleChange, handleSubmit } = actions;

  useEffect(() => {
    if (id) {
      setCurrentID(id);
      const jobToEdit = data.find((j) => j._id === id);
      if (jobToEdit) setForm(jobToEdit);
    }
  }, [id, data, setForm, setCurrentID]);

  if (!id) return <p>Invalid ID</p>;

  return (
    <div className="max-w-7xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-semibold text-gray-800 mb-6">
        Edit Lowongan Pekerjaan
      </h1>
      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded-xl shadow-sm space-y-6">
        <div>
          <label className="block text-sm font-medium mb-1">
            Judul Lowongan
          </label>
          <input
            type="text"
            name="title"
            value={form.title}
            onChange={handleChange}
            required
            className="w-full rounded-lg border px-4 py-2 focus:ring-2 focus:ring-indigo-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">
            Deskripsi Pekerjaan
          </label>
          <textarea
            name="job_description"
            value={form.job_description}
            onChange={handleChange}
            rows={4}
            required
            className="w-full rounded-lg border px-4 py-2 focus:ring-2 focus:ring-indigo-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">
            Kualifikasi Pekerjaan
          </label>
          <textarea
            name="job_qualification"
            value={form.job_qualification}
            onChange={handleChange}
            rows={3}
            required
            className="w-full rounded-lg border px-4 py-2 focus:ring-2 focus:ring-indigo-500"
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Job Type</label>
            <select
              name="job_type"
              value={form.job_type}
              onChange={handleChange}
              required
              className="w-full rounded-lg border px-4 py-2">
              {["On-Site", "Work From Home", "Hybrid"].map((t) => (
                <option key={t} value={t}>
                  {t}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">
              Lama Bekerja
            </label>
            <input
              type="text"
              name="job_tenure"
              value={form.job_tenure}
              onChange={handleChange}
              placeholder="Kontrak / Magang / Full Time"
              required
              className="w-full rounded-lg border px-4 py-2"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Status</label>
            <select
              name="job_status"
              value={form.job_status}
              onChange={handleChange}
              className="w-full rounded-lg border px-4 py-2">
              <option value={1}>Dibuka</option>
              <option value={0}>Ditutup</option>
            </select>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">
              Nama Perusahaan
            </label>
            <input
              type="text"
              name="company_name"
              value={form.company_name}
              onChange={handleChange}
              required
              className="w-full rounded-lg border px-4 py-2"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">
              URL Logo Perusahaan
            </label>
            <input
              type="url"
              name="company_image_url"
              value={form.company_image_url}
              onChange={handleChange}
              required
              className="w-full rounded-lg border px-4 py-2"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Kota</label>
            <input
              type="text"
              name="company_city"
              value={form.company_city}
              onChange={handleChange}
              required
              className="w-full rounded-lg border px-4 py-2"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">
              Gaji Minimum
            </label>
            <input
              type="number"
              name="salary_min"
              value={form.salary_min}
              onChange={handleChange}
              required
              className="w-full rounded-lg border px-4 py-2"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">
              Gaji Maksimum
            </label>
            <input
              type="number"
              name="salary_max"
              value={form.salary_max}
              onChange={handleChange}
              required
              className="w-full rounded-lg border px-4 py-2"
            />
          </div>
        </div>

        <button
          type="submit"
          className="px-6 py-2.5 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700">
          Update Lowongan
        </button>
      </form>
    </div>
  );
};

export default JobEditPage;
